module.exports = __webpack_public_path__ + "img/BR.3fc8860c.png";